module.exports = __webpack_public_path__ + "static/media/126.90aaaebd.mp3";